<template>
  <div>
    <user-deletion> </user-deletion>
    <p class="text-primary">
      Du kannst hier dein Profil löschen lassen. Damit wird dein Account nach
      Ablauf eines Zeitraumes gelöscht. Genaue Anweisungen zur Löschung deines
      Profils erhältst du mit einer E-Mail. Alle deine Daten werden nach der
      Löschung entfernt. Dein Profil kann anschließend nicht wiederhergestellt
      werden.
    </p>
    <p>
      Du bist schon dabei seit: {{ getCreatedAt() }}
      <br />
      Das sind: {{ registerTime }}
      <br />
      Deine Löschung würde in {{ deletionDelay / 1440 }} Tagen am
      {{ deletionTime }} wirksam.
    </p>
    <div class="form">
      <button
        type="submit"
        @click="$modal.show(`modal-profile-delete`)"
        class="btn btn-primary float-right"
      >
        Profil löschen
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      registerTime: "",
      deletionTime: ""
    };
  },
  mounted() {
    setInterval(() => {
      this.updateTime();
    }, 1000);

    this.updateTime();
  },
  computed: {
    customer() {
      return Laravel.user.customer_profile;
    },
    deletionDelay() {
      return Laravel.settings.deletionDelay;
    }
  },
  methods: {
    getCreatedAt() {
      return moment(this.customer.created_at).format("DD.MM.YYYY HH:mm:ss");
    },
    updateTime() {
      let registerTime = moment.duration(
        moment().diff(moment(this.customer.created_at))
      );

      if (registerTime.get("years") > 1) {
        this.registerTime = registerTime.get("years") + " Jahre ";
      } else if (registerTime.get("years") == 1) {
        this.registerTime = registerTime.get("years") + " Jahr ";
      } else {
        this.registerTime = "";
      }

      if (registerTime.get("month") > 1) {
        this.registerTime += registerTime.get("month") + " Monate ";
      } else if (registerTime.get("month") == 1) {
        this.registerTime += registerTime.get("month") + " Monat ";
      } else {
        this.registerTime += "";
      }

      if (registerTime.get("days") > 1) {
        this.registerTime += registerTime.get("days") + " Tage ";
      } else if (registerTime.get("days") == 1) {
        this.registerTime += registerTime.get("days") + " Tag ";
      } else {
        this.registerTime += "";
      }

      if (registerTime.get("minutes") > 1) {
        this.registerTime += registerTime.get("minutes") + " Minuten ";
      } else if (registerTime.get("minutes") == 1) {
        this.registerTime += registerTime.get("minutes") + " Minute ";
      } else {
        this.registerTime += "";
      }

      if (registerTime.get("seconds") > 1) {
        this.registerTime += registerTime.get("seconds") + " Sekunden ";
      } else if (registerTime.get("seconds") == 1) {
        this.registerTime += registerTime.get("seconds") + " Sekunde ";
      } else {
        this.registerTime += "";
      }

      this.deletionTime = moment()
        .add(this.deletionDelay, "minutes")
        .format("DD.MM.YYYY HH:mm:ss");
    }
  }
};
</script>
